<template>
  <div v-if="mounted" class="project">
    <div class="h3 dt w-100 tc center">
      <router-link class="link f1 black w-10 dtc v-mid pa1 tc" :to="prev()"><div class=""><img src="https://img.icons8.com/android/24/000000/back.png"></div></router-link>
      <h2 class="dtc v-mid w-80 tc f1-ns f2">{{ project.name }}</h2>
      <router-link class="w-10 f1 dtc v-mid link black pa1 tc" :to="next()"><div class=""><img src="https://img.icons8.com/android/24/000000/forward.png"></div></router-link>
    </div>
    <div class="row">
      <div class="column1">
        <img class="w-50-ns w-100" v-lazy="require(`@/assets/${project.images[0].link}`)"/>
      </div>
      <div class="column2 mt1-ns mb1-ns">
        <img v-lazy="require(`@/assets/${project.images[1].link}`)"/>
        <img v-lazy="require(`@/assets/${project.images[2].link}`)"/>
      </div>
      <div class="column2 mt1-ns mb1-ns">
        <img v-lazy="require(`@/assets/${project.images[3].link}`)"/>
        <img v-lazy="require(`@/assets/${project.images[4].link}`)">
      </div>
    </div>
    
    <div>
      <div class="mt3 center" v-if="project.images.length > 5">
        <img v-for="i in project.images.length -6" :key="i" class="w-25-ns w-50 bottom-images" v-lazy="require(`@/assets/${project.images[(i+5)%project.images.length].link}`)"/>
      </div>
    </div>

  </div>
</template>

<script>
import * as PROJECTS from '@/data.js'
export default {
  name: 'Project',
  data: function() {
    return {
      mounted: false,
      projLink: '',
      project: {},
      index: ''
    }
  },
  watch:{
    $route (to, from){
      this.projLink = this.$route.params.project;
      this.index = PROJECTS.findIndex(proj => proj.link === this.projLink)
      this.project = PROJECTS[this.index]
      this.mounted = true
    }
  },
  methods: {
    prev: function () {
      let prevLink = ''
      let prevIndex = (((this.index - 1) % PROJECTS.length) + PROJECTS.length) % PROJECTS.length
      return PROJECTS[prevIndex].link
    },
    next: function () {
      let nextLink = ''
      let nextIndex = (((this.index + 1) % PROJECTS.length) + PROJECTS.length) % PROJECTS.length
      return PROJECTS[nextIndex].link
    }
  },
  mounted: function() {
    this.projLink = this.$route.params.project;
    this.index = PROJECTS.findIndex(proj => proj.link === this.projLink)
    this.project = PROJECTS[this.index]
    this.mounted = true
  }
};
</script>

<style scoped>
* {
  box-sizing:border-box
}
.row {
  display: flex;
  flex-wrap: wrap;
  padding: 0 4px;
}
.column1 {
  -ms-flex: 50%;
  flex: 50%;
  max-width: 50%;
  padding: 0 4px;
}
.column2 {
  -ms-flex: 25%;
  flex: 25%;
  width: 25%;
  padding: 0 4px;
}
.column1 img {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  vertical-align: middle;
  width: 100%;
  height: 100%;
}
.column2 img {
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
  vertical-align: middle;
  width: 100%;
  object-fit: cover;
  height: 50%;
}
@media screen and (max-width: 800px) {
  .column1 {
    -ms-flex: 100%;
    flex: 100%;
    max-width: 100%;
  }
  .column1 img {
    margin-top: 0rem;
    margin-bottom: 0rem;
    padding: 0.25rem;
  }
  .column2 {
    -ms-flex: 100%;
    flex: 100%;
    max-width: 100%;
  }
  .column2 img {
    margin-top: 0rem;
    margin-bottom: 0rem;
    object-fit: cover;
    padding: 0.25rem;
  }
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.bottom-images {
  padding-right: 0.25rem;
  padding-left: 0.25rem;
  height: 300px;
}
@media screen and (max-width: 800px){
  .images {
    width: 100%;
  }
  .bottom-images {
    width: 100%;
    height: 100%;
  }
}
.project {
  margin-top: -20px;
}
</style>